import IconButton from '@/components/UI/buttons/IconButton'
import { ColorEnum } from '@/constants/color'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

interface CloseButtonProps {
    onPress: () => void
}

const CloseButton: FC<CloseButtonProps> = ({ onPress }) => {
    return (
        <IconButton
            size={24}
            Icon={() => <CloseIcon fill={ColorEnum.WHITE} height={16} width={16} />}
            highlightContainerColor={ColorEnum.RED_500}
            onPress={onPress}
            style={styles.button}
            testID="close-button"
        />
    )
}

const styles = StyleSheet.create({
    button: {
        position: 'absolute',
        top: 2,
        right: 2,
    },
})

export default CloseButton
